// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__6P1aM","rootCenter":"LoadMoreObserver_rootCenter__1DTS0","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__mrlzE"};